<template>
  <div class="feixe_bessel">
    <div class="conteudo" id="conteudo_feixe_bessel">
      <div class="form-group">
        <label for="feixe_de_bessel_prop">Ângulo de axicon</label>
        <input
          type="number"
          class="form-control"
          id="feixe_de_bessel_prop"
          placeholder="α"
          v-model="AnguloDeAxicon"
          value="AnguloDeAxicon"
          @change="EnviarAnguloDeAxicon"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "feixeBessel",
  data(){
    return{
      AnguloDeAxicon:Math.PI / 180
    }
  },
  methods: {
    EnviarAnguloDeAxicon: function() {
      this.$emit("DefineAnguloDeAxicon", {
          axicon: this.AnguloDeAxicon
      });
    }
  }
};
</script>